<template>
  <multiselect
      :loading="isSelectLoading"
      class="mb-4"
      v-model="localValue"
      id="user_id"
      label="label"
      track-by="label"
      :placeholder="$t('transactions.type_to_search')"
      :options="users"
      :searchable="true"
      @search-change="query => {debounceGetSelectOptions('users?limit=10', 'global', query)}"
      :close-on-select="true"
      select-label=""
      selected-label=""
      deselect-label="X ">
    <template slot="noResult">
      {{$t('global.no_results')}}
    </template>
  </multiselect>
</template>

<script>
import { debounce } from "lodash";

export default {
  name: "GetUserForm",
  props: {
    value: {
      type: Object,
    },
    resourceId: {
      type: String
    }
  },
  data() {
    return {
      isSelectLoading: false,
      debounceGetSelectOptions: {},
      selectOptions: {},
      users: [],
    }
  },
  computed: {
    localValue: {
      get: function () {
        return this.value;
      },
      set: function (value) {
        this.$emit('input', value);
      }
    }
  },
  mounted() {
    this.getSelectOptions('users?limit=10');
    this.debounceGetSelectOptions = debounce(this.getSelectOptions, 500);
  },
  methods: {
    getSelectOptions(url, filter_field, value) {
      this.isSelectLoading = true;
      const params = {
        filter: {}
      };

      const headers = {}

      if (this.resourceId) {
        headers['resource'] = this.resourceId;
      }

      params.filter[filter_field] = value;

      this.getData(url, {
        params,
        headers
      }).then(({data}) => {
        if (data && data.items) {
          this.users = data.items.map(option => {
            return {
              label: option.first_name ? `${option.first_name} ${option.last_name}, ${option.email}` : `${option.email}`,
              value: option.id
            }
          });
        }
      }).then(() => {
        this.$forceUpdate();
        this.isSelectLoading = false;
      })
    },
  }
}
</script>
